import {HibuUiConfig, TagOptions} from './config-types';

type ConfigLoadedAction = {
    readonly type: 'UI_CONFIG_LOADED';
    readonly uiConfig: HibuUiConfig;
} | {
    readonly type: 'CONFIG_LOAD_TAG_OPTIONS_FINISHED';
    readonly tagOptions: TagOptions;
};

export type ConfigAction = ConfigLoadedAction;

export const uiConfigLoaded = (data: HibuUiConfig): ConfigLoadedAction => {
    return {
        type: 'UI_CONFIG_LOADED',
        uiConfig: data
    };
};

export const configTagOptionLoaded = (data: TagOptions): ConfigLoadedAction => {
    return {
        type: 'CONFIG_LOAD_TAG_OPTIONS_FINISHED',
        tagOptions: data
    };
};
